import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OptimizeService } from '../../shared/optimize.service';
import { SharedService } from '../../shared/services/shared.service';
import { SharedAuthService } from '../../shared/shared.auth.service';
import { PortfolioHubService } from '../../techopsv4/services/portfolioHubV4Service';
import { DynamicContentModel } from '../landing-page-v4.component';

@Component({
    selector: 'app-landing-page-services',
    templateUrl: './landing-page-services.component.html',
    styleUrls: ['./landing-page-services.component.css'],
    standalone: false
})
export class LandingPageServicesComponent implements OnInit {
  tiles: any;
  visibleTiles: any[] = [];
  Reclassification: boolean;
  tcmAvailableData: any;
  tcmNextRefresh: any;
  tempTiles: any = [];
  tilesLength: any;
  @Input() dynamicContentData;
  public bodyTitle: DynamicContentModel = {} as DynamicContentModel;
  public services: string[] = [];
  public serviceObjects: DynamicContentModel[] = [];
  constructor(
    private optimize: OptimizeService,
    private sharedService: SharedService,
    private route: Router,
    private portfolioHubService: PortfolioHubService,
    private sharedAuthService: SharedAuthService,
    
  ) {}

  ngOnInit(): void {
    this.getYearMonth();
    sessionStorage.removeItem('groupList');
    sessionStorage.removeItem('segmentList');
  }

  ngOnChanges() {
    if (this.dynamicContentData) {
      if (this.dynamicContentData.Body_Title) {
        this.bodyTitle = this.dynamicContentData.Body_Title[0] ? this.dynamicContentData.Body_Title[0] : {};
      }
      if (this.dynamicContentData.Body_Content && this.dynamicContentData.Body_Content.length > 0) {
        this.serviceObjects = this.dynamicContentData.Body_Content;
        this.serviceObjects = this.serviceObjects.sort((a, b) => (a.Occurance < b.Occurance ? -1 : 1));
        this.services = this.serviceObjects.map(a => {
          if (a.visibility == 'True') {
            return a.Content;
          }
        });
      }
      if (this.dynamicContentData.Tile && this.dynamicContentData.Tile.length > 0) {
        let tilesObjects: DynamicContentModel[] = this.dynamicContentData.Tile;
        tilesObjects = tilesObjects.sort((a, b) => (a.Occurance < b.Occurance ? -1 : 1));
        const tilesArray = [];
        tilesObjects.forEach(tile => {
          const newTile = {};
          newTile['Tile'] = tile.Content;
          newTile['SubTitle'] = tile.SubTitle;
          newTile['Description'] = tile.Description;
          newTile['CostData'] = tile.CostData;
          newTile['Visibility'] = this.getTileVisibility(tile);
          newTile['icon'] = tile.icon;
          newTile['order'] = tile.Occurance;
          newTile['Url_Path'] = tile.Url_Path;
          tilesArray.push(newTile);
        });
        this.tiles = tilesArray;
        this.visibleTiles = this.tiles.filter(tile => tile.Visibility === 'True');
      }
    }
  }
  tileslists() {
    if (JSON.parse(sessionStorage.getItem('tiles'))) {
      this.tiles = JSON.parse(sessionStorage.getItem('tiles'));
      this.tempTiles = this.tiles.filter(x => x.Visibility === 'True');
      this.tilesLength = this.tempTiles.length;
    }
  }

  getYearMonth() {
    this.optimize.getCurrentYear().subscribe(
      (res: any) => {
        if (res) {
          this.tcmAvailableData = JSON.parse(sessionStorage.getItem('config')).avialableData;
          this.tcmNextRefresh = JSON.parse(sessionStorage.getItem('config')).nextRefreshData;
          const ocuurance1 = this.tcmNextRefresh.indexOf('-');
          const ocuurance2 = this.tcmNextRefresh.indexOf('-', 3);
          this.tcmNextRefresh = this.tcmNextRefresh.replace(
            this.tcmNextRefresh.substr(ocuurance1 + 1, ocuurance2 - ocuurance1 - 1),
            this.tcmNextRefresh.substr(ocuurance1 + 1, 3)
          );
          return res;
        }
      },
      err => {
        console.log('Error:', err);
        sessionStorage.removeItem('config');
      }
    );
  }

  navigate(event) {
    let url = event.Url_Path;
    if (event.Tile == 'Portfolio Hub') {
      this.portfolioHubService.porfolioSelectedFromFinance = false;
    }
    if(event.Tile == 'Work Queues') {
      url = `${url}?selectedTab=requests`;
    }
    if(event.Tile == 'Reclassification Portal'){
      const label='Submit a request'
      url = `${url}?selectedTab=${label.replace(/ /g, '-')}&selectedReclass=appReclassification`;
    }
    if(event.Tile == 'Capital Demand'){
      const label='Investment Summary'
      url = `${url}?selectedTab=${label.replace(/ /g, '-')}`;
    }
    this.route.navigateByUrl(url);
  }
  getTileVisibility(tile) {
    if (
      tile.Audience == 'EA' &&
      !tile.Role_Visibility.split(',').includes(this.sharedAuthService.getAuthorizationForEA())
    )
      return 'False';
    else if (tile.Audience == 'CD' && !this.sharedAuthService.getAuthorizationForCD()) return 'False';
    else if (tile.Audience == 'Public' && tile.Role_Visibility != 'All') return 'False';
    else return tile.visibility;
  }

    getTooltipClass(i: number): string {
    if ((i + 1) % 5 === 0) return 'reverse-tooltip';
    if ((i + 1) === 4 || (i + 1) === 9 || (i + 1) === 14) return 'reverse-tooltip-three';
    return 'background-img';
  }
  getTooltipStyle(): object {
    return { 'background-image': 'url(assets/imagesV4/ourservices.jpeg)' };
  }
  getTooltipArrowStyle(i: number): object {
    const left = ((i + 1) % 5 === 0 || (i + 1) === 4 || (i + 1) === 9 || (i + 1) === 14) ? '95%' : '10%';
    return { left };
  }
}
